/** Au moins un contenu « intervenant » renseigné (sinon rien n’est affiché sur la fiche). */
export function hasSpeakerPublicContent(event) {
    return Boolean(
        event?.speaker_name?.trim() ||
        event?.speaker_title?.trim() ||
        event?.speaker_description?.trim()
    );
}

const CIVILITY_PREFIX = new Set(['Monsieur', 'Madame', 'Monsieur et Madame']);

/** Ligne principale : civilité + nom, ou titre seul si pas de nom. */
export function formatPrimarySpeakerLine(event) {
    const name = event?.speaker_name?.trim();
    if (name) {
        const civ = event?.speaker_civility && CIVILITY_PREFIX.has(event.speaker_civility);
        return civ ? `${event.speaker_civility} ${name}` : name;
    }
    return event?.speaker_title?.trim() || '';
}
